<template>
  <b-modal
    size="xl"
    id="modal-question"
    :title="editItem ? 'Edit vérification' : 'Ajout vérification'"
    hide-footer
    class="m-0"
  >
    <b-form @submit.prevent="onSubmit">
      <b-row class="mb-1">
        <b-col sm="6" class="pl-0">
          <!-- <b-button block @click="getAll" class="mr-1 mb-2">Tous</b-button> -->

          <!-- <div>
            <h5 class="mb-3 text-center">Technologies</h5>
            <b-form-select
              v-model="form.technologies"
              :options="technologies"
              @change="selectedTechnology"
            ></b-form-select>
          </div> -->
          <div>
            <h5 class="mb-3 text-center">Composants</h5>

            <b-form-select
              v-model="form.components"
              :options="components"
              :select-size="components.length + 13"
              multiple
              required
              @change="selectedComponents"
            ></b-form-select>
          </div>
        </b-col>

        <!-- <b-col sm="1" class="border-right">
          <h5 class="mb-3 text-center">Spécificités</h5>

          <b-row class="mt-2 pb-3 border-bottom">
            <div
              class="mr-1 border-bottom"
              v-for="component in form.components"
              :key="component.id"
            >
            <div v-if="component.partsAndSpecificities.length > 0">
              <h5>{{ component.name }}</h5>
              <b-form-group
                v-for="(partSpecs, index) in component.partsAndSpecificities"
                :key="index"
                :label="partSpecs.part.name"
              >

                <b-form-checkbox-group
                  v-model="selectedSpecificities"
                  :name="partSpecs.part.name"
                  @change="checkedParts"
                >
                  <b-form-checkbox
                    v-for="spec in partSpecs.specificities"
                    :key="spec.id"
                    :value="spec"
                  >
                    {{ spec.name }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
            </div>
          </b-row>
        </b-col> -->
        <b-col sm="6">
          <!-- Usages -->
          <!-- <b-card
            class="mb-2"
            header-class=" text-center font_bold"
            border-variant="info"
            header="Usages"
          >
            <b-row>
              <b-col sm="12">
                <b-form-group>
                  <b-form-checkbox-group
                    v-model="form.usages"
                    :options="usages"
                    name="usages"
                    :required="form.usages.length === 0"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card> -->

          <!-- Ordre affichage -->
          <b-card
            class="mb-2"
            header-class=" text-center font_bold"
            border-variant="info"
            header="Ordre affichage"
          >
            <b-row>
              <b-col sm="6">
                <b-form-group>
                  <b-form-radio
                    v-model="form.properties.displayOrder"
                    name="form-displayOrder"
                    value="normal"
                    >Normal</b-form-radio
                  >
                  <b-form-radio
                    v-model="form.properties.displayOrder"
                    name="form-displayOrder"
                    value="first"
                    >En premier</b-form-radio
                  >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="N° ordre" label-for="nested-order">
                  <b-form-input
                    v-model="form.properties.orderNumber"
                    id="nested-order"
                    autocomplete="off"
                    type="number"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <!-- Question form -->
          <b-card bg-variant="light">
            <b-form-group
              label="Intitulé vérification"
              label-for="nested-question"
              label-size="lg"
            >
              <b-form-textarea
                required
                v-model="form.question"
                id="nested-question"
              ></b-form-textarea>
            </b-form-group>
            <b-row>
              <b-col sm="6">
                <b-form-group label="Catégorie vérification" label-for="nested-category">
                  <b-form-select v-model="form.categoryId" @change="changeCat">
                    <option
                      v-for="cat in categories"
                      :key="cat.id"
                      :value="cat.id"
                    >
                      {{ cat.name }}
                    </option>
                  </b-form-select>
                </b-form-group>

                <b-form-group label="Priorité" label-for="nested-priority">
                  <b-form-input
                    v-model="form.priority"
                    id="nested-priority"
                    autocomplete="off"
                    disabled
                  ></b-form-input>
                </b-form-group>

                <!-- <b-form-group label="Etapes" label-for="nested-step">
                  <b-form-select
                    v-model="form.step"
                    :options="['Conception', 'Mise en oeuvre', 'Réglage']"
                    :select-size="3"
                    multiple
                  ></b-form-select>
                </b-form-group> -->

                <b-form-group label="Aide" label-for="nested-help">
                  <b-form-textarea
                    rows="8"
                    v-model="form.help"
                    id="nested-help"
                  ></b-form-textarea>
                </b-form-group>
                <!-- <b-form-group label="Lien" label-for="nested-link">
                  <b-form-textarea
                    rows="3"
                    v-model="form.properties.link"
                    id="nested-link"
                  ></b-form-textarea>
                </b-form-group> -->
                <b-form-group label="Documents" label-for="nested-images">
                  <b-form-file
                    id="file"
                    ref="file"
                    multiple
                    placeholder="Sélectionnez ou glisser un fichier ici"
                    drop-placeholder="Glissez le fichier ici..."
                    browse-text="Parcourir"
                  ></b-form-file>
                </b-form-group>
                <b-button
                  size="sm"
                  v-if="showDocButton"
                  v-b-modal.modal-1
                  variant="secondary"
                  @click="getImages()"
                >
                  {{ form.properties.images.length }} Documents
                </b-button>

                <b-form-group label="Temps" label-for="nested-time">
                  <b-form-select
                    v-model="form.time"
                    :options="['Fort', 'Moyen', 'Faible', 'Variable']"
                    required
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Matériel" label-for="nested-equipment">
                  <b-form-select
                    v-model="form.equipment"
                    multiple
                    :select-size="23"
                    :options="equipment"
                  ></b-form-select>
                </b-form-group>
                <!-- <b-form-group
                  label="Localisations MI"
                  label-for="sort-by-select"
                >
                  <b-form-select
                    v-model="form.locationsMI"
                    :options="locations"
                    :select-size="locations.length"
                    @change="selectLocal(form.locationsMI)"
                    multiple
                  ></b-form-select>
                </b-form-group>
                <b-form-group
                  label="Localisations LC"
                  label-for="sort-by-select"
                >
                  <b-form-select
                    v-model="form.locationsLC"
                    :options="locations"
                    :select-size="locations.length"
                    @change="selectLocal(form.locationsLC)"
                    multiple
                  ></b-form-select>
                </b-form-group>
                <b-form-group
                  label="Localisations Ter"
                  label-for="sort-by-select"
                >
                  <b-form-select
                    v-model="form.locationsTer"
                    :options="locations"
                    :select-size="locations.length"
                    multiple
                  ></b-form-select>
                </b-form-group> -->
              </b-col>
              <b-col sm="6">
                <b-form-group label="Unités possibles">
                  <b-form-select
                    v-model="form.possibleUnits"
                    :options="possibleUnits"
                    :select-size="possibleUnits.length"
                    multiple
                    :required="
                      form.answerType !== 'multipleChoice' ? true : false
                    "
                  ></b-form-select>
                </b-form-group>
                <b-form-group label="Source (interne)" class="mt-5">
                  <b-form-textarea
                    rows="6"
                    v-model="form.properties.source"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group label="Commentaire (interne)" class="mt-5">
                  <b-form-textarea
                    rows="6"
                    v-model="form.comment"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <!-- Réponses et traitement -->
        <b-col sm="12" class="mt-5 border-top">
          <h4 class="mb-3 mt-3 text-center">Réponses</h4>

          <b-col sm="12">
            <b-row>
              <b-col>
                <b-form-group
                  label="Valeur référence"
                  class="border-bottom pb-2"
                >
                  <b-form-radio-group
                    v-model="form.autoReference"
                    @change="onAutoRefChange"
                    :options="[
                      { text: 'Caractéristiques installation', value: true },
                      { text: 'A saisir', value: false },
                    ]"
                    button-variant="outline-secondary"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>
                <b-form-group
                  class="border-bottom pb-2"
                  v-if="form.autoReference"
                >
                  <!-- <b-form-radio-group
                    v-model="form.autoreferenceValue"
                    @change="onAutoRefValueChange"
                    :options="[
                      {
                        text: 'Valeur documentaire',
                        value: 'documentaryValue',
                      },
                      {
                        text: 'Caractéristiques installation',
                        value: 'installationCharacteristic',
                      },
                    ]"
                    button-variant="outline-secondary"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group> -->
                  <h2>Caractéristiques installation</h2>
                  <!-- <b-form-radio-group
                    v-model="form.autoreferenceValue"
                    @change="onAutoRefValueChange"
                    :options="[
                     {
                        text: 'Caractéristiques installation',
                        value: 'installationCharacteristic',
                      },
                    ]"
                    button-variant="outline-secondary"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group> -->
                </b-form-group>
                <b-form-group
                  label="Caractéristiques installation"
                  class="border-bottom pb-2"
                  v-if="
                    form.autoreferenceValue === 'installationCharacteristic'
                  "
                >
                  <b-form-radio-group
                    @change="charChange"
                    v-model="form.installationCharacteristic"
                    :options="[
                      {
                        text: 'Besoin ECS journalier',
                        value: {
                          text: 'Besoin ECS journalier',
                          name: 'besoinECSJournalier',
                        },
                      },
                      {
                        text: 'Volume solaire total',
                        value: {
                          text: 'Volume solaire total',
                          name: 'volumeSolaireTotal',
                        },
                      },
                      {
                        text: 'Surface capteurs total',
                        value: {
                          text: 'Surface capteurs total',
                          name: 'surfaceCapteursTotal',
                        },
                      },
                      {
                        text: 'Volume stockage solaire(L/m² de capteurs)',
                        value: {
                          text: 'Volume stockage solaire',
                          name: 'volumeStockageSolaire',
                        },
                      },
                      {
                        text: 'Hauteur manomètrique (m)',
                        value: {
                          text: 'Hauteur manomètrique',
                          name: 'hauteurManometrique',
                        },
                      },
                      {
                        text: 'Pression de gonflage du vase',
                        value: {
                          text: 'Pression de gonflage du vase',
                          name: 'pgonflage',
                        },
                      },
                      {
                        text: 'Pression de remplissage',
                        value: {
                          text: 'Pression de remplissage',
                          name: 'pressionRemplissage',
                        },
                      },
                      {
                        text: 'Volume vase',
                        value: {
                          text: 'Volume vase',
                          name: 'volumeVase',
                        },
                      },
                      {
                        text: 'Debit minimal',
                        value: {
                          text: 'Debit minimal',
                          name: 'debitMinimal',
                        },
                      },
                      {
                        text: 'Si plusieurs ballons',
                        value: {
                          text: 'Si plusieurs ballons',
                          name: 'plusieursBallons',
                        },
                      },
                    ]"
                    button-variant="outline-secondary"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>
                <b-form-group
                  label="Type réponse"
                  class="border-bottom pb-2"
                  v-if="(!form.autoReference || form.installationCharacteristic.name === 'plusieursBallons')"
                >
                  <b-form-radio-group
                    v-model="form.answerType"
                    :options="[
                      { text: 'Nombre', value: 'number' },
                      { text: 'Choix multiple', value: 'multipleChoice' },
                    ]"
                    button-variant="outline-secondary"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                </b-form-group>

                <!-- ANSWERS -->
                <b-card
                  v-for="(answer, index) in form.answers"
                  :key="index"
                  class="border-bottom mt-2 mb-5"
                  bg-variant="light"
                  header-bg-variant="info"
                  :header="String(index + 1)"
                  header-class="cardHeader"
                >
                  <b-row>
                    <b-col
                      cols="2"
                      class="mt-2"
                      v-if="form.answerType === 'number' || ((form.autoReference  && form.installationCharacteristic.name !== 'plusieursBallons') && form.installationCharacteristic.name !== 'plusieursBallons')"
                    >
                      <span class="ml-5">Si valeur saisie</span>
                    </b-col>
                    <b-col cols="5" v-if="form.answerType === 'number'">
                      <b-form-group
                        label="+/- Coefficient de tolérance sur valeur saisie"
                        label-for="sort-by-select"
                        label-cols-sm="8"
                        content-cols-sm="4"
                        class="mb-3"
                        :id="'tooltip-button-' + index"
                      >
                        <b-input-group append="%">
                          <b-form-input
                            v-model="answer.toleranceCoefficientOnEnteredValue"
                            type="number"
                            autocomplete="off"
                            @blur="
                              answer.toleranceCoefficientOnEnteredValue =
                                !!answer.toleranceCoefficientOnEnteredValue &&
                                Math.abs(
                                  answer.toleranceCoefficientOnEnteredValue
                                ) >= 0
                                  ? Math.abs(
                                      answer.toleranceCoefficientOnEnteredValue
                                    )
                                  : null
                            "
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="1"
                      v-if="form.answerType === 'number' || (form.autoReference  && form.installationCharacteristic.name !== 'plusieursBallons')"
                    >
                      <b-form-select
                        v-model="answer.operator"
                        :options="operators"
                        required
                      ></b-form-select>
                    </b-col>
                    <b-col
                      cols="4"
                      v-if="
                        form.answerType === 'multipleChoice' ||
                        form.answerType === 'number'
                      "
                    >
                      <b-form-group
                        :label="
                          form.answerType === 'multipleChoice'
                            ? 'Si valeur saisie = '
                            : 'à'
                        "
                        :label-cols="
                          form.answerType === 'multipleChoice' ? '5' : '1'
                        "
                        v-if="(!form.autoReference || form.installationCharacteristic.name === 'plusieursBallons') || form.installationCharacteristic.name === 'plusieursBallons'"
                      >
                        <b-form-textarea
                          v-if="form.answerType === 'multipleChoice'"
                          v-model="answer.valueAnswer"
                          required
                        ></b-form-textarea>
                        <b-input-group>
                          <b-form-input
                            type="number"
                            v-if="form.answerType === 'number'"
                            v-model="answer.valueAnswer"
                            autocomplete="off"
                            step="0.0000001"
                            placeholder="nombre"
                            @blur="
                              answer.valueAnswer =
                                !!answer.valueAnswer &&
                                Math.abs(answer.valueAnswer) >= 0
                                  ? Math.abs(answer.valueAnswer)
                                  : null
                            "
                            required
                          ></b-form-input>
                          <b-form-select
                            v-model="answer.unit"
                            :options="units"
                            v-if="form.answerType === 'number'"
                          ></b-form-select>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="4"
                      v-if="
                        form.autoreferenceValue === 'installationCharacteristic'
                         && form.installationCharacteristic.name !== 'plusieursBallons'
                      "
                    >
                      <b-form-group
                        :label="form.installationCharacteristic.text"
                        label-for="sort-by-select"
                        label-cols-sm="6"
                        content-cols-sm="6"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-3"
                      >
                        <b-form-select
                          v-model="answer.documentaryValueModifierOperator"
                          :options="['', 'x', '+', '-']"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="2"
                      v-if="
                        (form.autoReference  && form.installationCharacteristic.name !== 'plusieursBallons') &&
                        answer.documentaryValueModifierOperator
                      "
                    >
                      <b-form-group
                        content-cols-sm="11"
                        class="mb-3"
                        :id="'tooltip-button-' + index"
                      >
                        <b-form-input
                          v-model="answer.documentaryValueModifierValue"
                          @blur="
                            answer.documentaryValueModifierValue =
                              !!answer.documentaryValueModifierValue &&
                              Math.abs(answer.documentaryValueModifierValue) >=
                                0
                                ? Math.abs(answer.documentaryValueModifierValue)
                                : null
                          "
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="nombre"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="3" v-if="(form.autoReference  && form.installationCharacteristic.name !== 'plusieursBallons')">
                      <b-form-group
                        :label="
                          (answer.operator === '<'
                            ? ') -'
                            : answer.operator === '='
                            ? ') +/-'
                            : ') +') + ' Coefficient de tolérance'
                        "
                        label-for="sort-by-select"
                        label-cols-sm="6"
                        content-cols-sm="6"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-3"
                        :id="'tooltip-button-' + index"
                      >
                        <b-input-group
                          label="Coefficient de tolérance"
                          append="%"
                        >
                          <b-form-input
                            v-model="answer.toleranceCoefficient"
                            type="number"
                            autocomplete="off"
                            @blur="
                              answer.toleranceCoefficient =
                                !!answer.toleranceCoefficient &&
                                Math.abs(answer.toleranceCoefficient) >= 0
                                  ? Math.abs(answer.toleranceCoefficient)
                                  : null
                            "
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-3 pt-5 border-top">
                    <b-col cols="2">
                      <b-form-checkbox
                        v-model="answer.isDefault"
                        @change="isDefaultChange(index, answer.isDefault)"
                        :value="true"
                        :unchecked-value="false"
                      >
                        Pas de défaut
                      </b-form-checkbox>
                    </b-col>
                    <b-col cols="8">
                      <b-form-group
                        :label="
                          answer.isDefault
                            ? 'Explication (optionnelle)'
                            : 'Nature défaut'
                        "
                        label-for="nested-then"
                        label-cols-sm="3"
                        content-cols-sm="9"
                        label-align-sm="right"
                        class="pb-5 border-bottom"
                      >
                        <b-form-textarea
                          v-model="answer.then"
                          :required="!answer.isDefault"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="4" v-if="!answer.isDefault">
                      <b-form-group
                        label="Impact à court terme"
                        label-for="sort-by-select"
                        class="mb-3"
                      >
                        <b-form-select
                          v-model="answer.shortTermImpact"
                          :options="shortTermImpact"
                          @change="calculateWeightAndPriority"
                        ></b-form-select>
                      </b-form-group>

                      <b-form-group
                        label="Impact à long terme"
                        label-for="sort-by-select"
                        class="mb-3"
                      >
                        <b-form-select
                          v-model="answer.longTermImpact"
                          :options="longTermImpact"
                          @change="calculateWeightAndPriority"
                        ></b-form-select>
                      </b-form-group>

                      <b-form-group
                        label="Fréquence"
                        label-for="sort-by-select"
                        class="mb-3"
                      >
                        <b-form-select
                          v-model="answer.frequency"
                          :options="frequency"
                          @change="calculateWeightAndPriority"
                        ></b-form-select>
                      </b-form-group>
                      <b-form-group
                        label="Correction"
                        label-for="sort-by-select"
                        class="mb-3"
                      >
                        <b-form-textarea
                          v-model="answer.correction"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group
                        label="Nature de l'impact"
                        label-for="sort-by-select"
                      >
                        <b-form-select
                          v-model="answer.natureOfImpact"
                          :options="natureOfImpact"
                          :select-size="natureOfImpact.length"
                          multiple
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label="Commentaire (interne)"
                        label-for="sort-by-select"
                        class="mt-5"
                      >
                        <b-form-textarea
                          v-model="answer.comment"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <div class="text-right">
                    <b-button
                      v-if="
                        answer === form.answers[form.answers.length - 1] &&
                        
                        index !== 0
                      "
                      @click="removeAnswer"
                      class="mt-5 mb-5 mr-5"
                      variant="outline-secondary"
                    >
                      <h4>-</h4>
                    </b-button>
                    <b-button
                      v-if="
                        answer === form.answers[form.answers.length - 1]
                      "
                      @click="addAnswer"
                      class="mt-5 mb-5 w_250"
                      variant="secondary"
                      :disabled="
                        !answer.isDefault &&
                        (((!form.autoReference || form.installationCharacteristic.name === 'plusieursBallons') || form.installationCharacteristic.name === 'plusieursBallons')
                          ? answer.then === '' ||
                            answer.operator === '' ||
                            answer.valueAnswer === ''
                          : answer.then === '' || answer.operator === '')
                      "
                    >
                      <b-icon icon="plus" font-scale="2"></b-icon>
                    </b-button>
                  </div>
                </b-card>

                <!-- TEST -->
                <!--      -->
                <!-- <b-card v-if="form.answerType === 'number'">
                  <b-card-header> Test réponse (expérimental) </b-card-header>
                  <b-form inline>
                    <label class="mr-sm-2" for="inline-form-custom-select-pref"
                      >Valeur de départ</label
                    >
                    <b-form-input
                      v-model="userAnswerBeginValue"
                      type="number"
                    ></b-form-input>
                    <label class="mr-sm-2" for="inline-form-custom-select-pref"
                      >Valeur d'arrivée</label
                    >

                    <b-form-input
                      v-model="userAnswerMax"
                      type="number"
                    ></b-form-input>
                    <label class="mr-sm-2" for="inline-form-custom-select-pref"
                      >Intervalle</label
                    >

                    <b-form-input
                      v-model="userAnswerInterval"
                      type="number"
                    ></b-form-input>
                  </b-form>
                  <b-button
                    @click="
                      testAnswers(
                        form.autoReference,
                        form.answerType,
                        form.answers
                      )
                    "
                    >Tester réponses</b-button
                  >
                  <p>{{ userAnswerTest }}</p>
                  <p>{{ testResult }}</p>
                </b-card> -->
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
      <b-col offset-sm="2" sm="8">
        <b-row>
          <b-col>
            <b-card :bg-variant="form.active ? 'success' : 'warning'">
              <b-form-group
                label="Publié"
                label-for="formActive"
                label-cols-sm="2"
                label-align-sm="right"
                content-cols-sm="8"
                class="mb-0"
              >
                <b-form-select
                  v-model="form.active"
                  id="formActive"
                  :options="[
                    { text: 'Oui', value: true },
                    { text: 'Non', value: false },
                  ]"
                ></b-form-select>
              </b-form-group>
            </b-card>
          </b-col>
          <b-col>
            <b-card :bg-variant="form.validate ? 'success' : 'warning'">
              <b-form-group
                label="Validé"
                label-for="formActive"
                label-cols-sm="2"
                label-align-sm="right"
                content-cols-sm="8"
                class="mb-0"
              >
                <b-form-select
                  v-model="form.validate"
                  id="formValidate"
                  :options="[
                    { text: 'Oui', value: true },
                    { text: 'Non', value: false },
                  ]"
                ></b-form-select>
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-alert variant="success" :show="success"
        >Vérification {{ editItem ? "modifiée" : "créée" }}</b-alert
      >
      <b-button
        block
        class="mt-3 mb-3"
        type="submit"
        variant="primary"
        :disabled="success"
        ><span class="font-weight-bold fs_15">{{
          editItem ? "Modifier" : "Ajouter nouvelle vérification"
        }}</span>
        <b-spinner small class="ml-3" v-if="isLoading"></b-spinner>
      </b-button>
    </b-form>

    <!-- MODAL DOCUMENTS -->
    <b-modal
      id="modal-1"
      scrollable
      title="Documents"
      size="lg"
      cancel-title="Annuler"
    >
      <div v-if="!isFullscreen">
        <b-row>
          <b-col cols="6" v-for="image in imageUrl" :key="image.name">
            <img :src="image.src" width="200" fluid alt="Responsive image" />
            <b-button variant="danger" @click="deleteFile(image, 'image')"
              >Supprimer</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" v-for="pdf in pdfUrl" :key="pdf.name">
            <div>
              <div @click="openFile(pdf.src)">
                <pdf :src="pdf.src"></pdf>
              </div>
              <b-button variant="danger" @click="deleteFile(pdf, 'pdf')"
                >Supprimer</b-button
              >
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="isFullscreen">
        <pdf
          :src="sourceFile"
          v-for="i in numPages"
          :key="i"
          :page="i"
          style="height: 100%"
        ></pdf>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
// import VGrid from "@revolist/vue-datagrid";
require("json-circular-stringify");
import imageCompression from "browser-image-compression";
import pdf from "vue-pdf";

export default {
  name: "ModalVerification",
  props: {
    editItem: Object,
    duplicItem: Object,
  },
  data() {
    return {
      cloneItem: {},
      pageCount: 0,
      numPages: undefined,
      form: {
        cat: {},
        categoryId: null,
        usages: [],
        // buildings: [],
        components: [],
        documentaryAnalysis: false,
        visualCheck: true,
        measure: true,
        question: "",
        equipment: [],
        step: [],
        possibleUnits: [],
        help: "",
        criteria: "",
        time: "Faible",
        // parts: [],
        // specificities: [],
        // partsAndSpecificities: [{ part: { name: "" }, specificities: [] }],
        // locationsMI: [],
        // locationsLC: [],
        // locationsTer: [],
        answerType: "number",
        autoReference: false,
        autoreferenceValue: "",
        installationCharacteristic: {},
        function: "",
        comment: "",
        properties: {},
        lastModification: "",
        active: false,
        validate: false,
        priority: 0,
        // weight: 0,
        answers: [
          {
            valueAnswer: "",
            toleranceCoefficient: "0",
            isDefault: false,
            documentaryValueModifierOperator: "",
            documentaryValueModifierValue: "",
            operator: "=",
            unit: "mm",
            shortTermImpact: "Aucun",
            longTermImpact: "Aucun",
            natureOfImpact: ["Aucun"],
            correction: "",
            frequency: "Aucune",
            then: "",
          },
        ],
      },
      // buildings: [],
      // usages: [],
      filteredUsages: [],
      // technologies: [],
      components: [],
      tempSelectedComponent: [],
      filterComponents: [],
      // locations: [],
      success: false,
      isLoading: false,
      operators: ["=", "<=", "<", ">=", ">"],
      show: false,
      equipment: [
        "Mètre ruban",
        "Pied à coulisse",
        "Boussole (ou appli)",
        "Clinomètre (ou appli)",
        "Thermomètre de contact",
        "Thermomètre infrarouge",
        "Hygromètre",
        "Débitmètre à pression différentielle",
        "Débitmètre à ultrasons",
        "Réfractomètre",
        "Mesureur pH",
        "Manomètre",
        "Manomètre pour robinet",
        "Verre doseur",
        "Cône de mesure",
        "Anémomètre thermique (fil chaud)",
        "Anémomètre thermique (quadrillage)",
        "Anémomètre à hélice",
        "Sonde Pitot",
        "Analyseur de combustion",
        "Déprimomètre",
        "Lampe",
        "Luxmètre",
      ],
      // parts: [],
      // partsAndSpecificities: [],
      // specificities: [],
      // selectedSpecificities: [],
      possibleUnits: [
        "",
        "mm",
        "cm",
        "m",
        "°",
        "l",
        "m3",
        "°C",
        "K",
        "%",
        "bar",
        "Pa",
        "hPa",
        "kPa",
        "mmCE",
        "mCE",
        "kWh",
        "MWh",
        "W",
        "kW",
        "W/m²",
        "W/m²/K",
        "lux",
        "lm",
        "lm/W",
        "l/min",
        "l/h",
        "m3/s",
        "m3/h",
        "kg/h",
        "m/s",
        "min",
        "h",
      ],
      units: [
        "",
        "mm",
        "cm",
        "m",
        "°",
        "l",
        "m3",
        "°C",
        "K",
        "%",
        "bar",
        "Pa",
        "hPa",
        "kPa",
        "mmCE",
        "mCE",
        "kWh",
        "MWh",
        "W",
        "kW",
        "W/m²",
        "W/m²/K",
        "lux",
        "lm",
        "l/min",
        "l/h",
        "m3/s",
        "m3/h",
        "kg/h",
        "m/s",
      ],
      shortTermImpact: ["Aucun", "Faible", "Moyen", "Fort", "Hors service"],
      longTermImpact: ["Aucun", "Faible", "Moyen", "Fort", "Hors service"],
      natureOfImpact: [
        "Aucun",
        "Surconsommation d'énergie",
        "Surconsommation d'eau",
        "Inconfort thermique",
        "Insatisfaction besoin ECS",
        "Insatisfaction besoin chauffage",
        "Insatisfaction besoin rafraîchissement",
        "Inconfort acoustique",
        "Inconfort visuel",
        "Dégradation du système",
        "Dégradation du bâti",
        "Pollution",
        "Difficulté d'exploitation/maintenance",
        "Installation hors-service",
        "Risque sanitaire",
        "Risque brûlure",
        "Risque incendie",
        "Risque d'accident",
        "Risque de surchauffe",
        "Baisse des performances",
      ],
      correction: "",
      frequency: ["Aucune", "Faible", "Moyen", "Fort", "Variable"],
      testResult: "",
      userAnswerMax: 200,
      userAnswerBeginValue: 1,
      userAnswerInterval: 1,
      userAnswerTest: 0,
      priorityArray: [],
      // weightArray: [],
      imageUrl: [],
      pdfUrl: [],
      isFullscreen: false,
      sourceFile: "",
      showDocButton: false,
      categories: [],
    };
  },
  components: {
    pdf,
  },
  created() {
    // console.log(this.editItem);
    if (this.editItem) {
      this.getImages();
      this.cloneItem = { ...this.editItem };
    }
    if (this.duplicItem) {
      this.cloneItem = { ...this.duplicItem };
      delete this.cloneItem.id;
      delete this.cloneItem.createdAt;
    }
    this.getAll();
  },
  mounted() {
    console.log("mounted");
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      // console.log('Modal is about to be shown', bvEvent, modalId)
      if (modalId === "modal-1") {
        this.isFullscreen = false;
      }
    });
  },
  methods: {
    getAll() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getAll", {
        method: "POST",
        // body: JSON.stringify({
        // componentId: 1,
        // }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          this.components = json.component.map((item) => {
            item.value = item;
            item.text = item.name;
            return { ...item };
          });
          this.categories = json.category;

          this.components.sort((a, b) => a.name.localeCompare(b.name));

          // IF EDIT or duplicate
          if (this.editItem || this.duplicItem) {
            this.form = { ...this.cloneItem };
            if (!this.form.installationCharacteristic) {
              this.form.installationCharacteristic = {};
            }
            let selecSys = this.components.filter((item) => {
              return this.cloneItem.componentIds.includes(item.id);
            });
            // Pour que form.components soit reactif
            this.$set(this.form, "components", selecSys);

            if (
              this.form.properties.images &&
              this.form.properties.images.length > 0
            ) {
              this.showDocButton = true;
            }

            this.calculateWeightAndPriority();
          }
          if (!this.form.properties.displayOrder) {
            this.form.properties.displayOrder = "normal";
          }

          if (!this.form.answers) {
            this.form.answers = [
              {
                valueAnswer: "",
                toleranceCoefficient: "0",
                isDefault: false,
                operator: "=",
                unit: "mm",
                shortTermImpact: "Aucun",
                longTermImpact: "Aucun",
                natureOfImpact: ["Surconsommation d'énergie"],
                correction: "",
                frequency: "Aucune",
                then: "",
              },
            ];
          }
        });
    },
    getImages() {
      this.pdfUrl = [];
      this.imageUrl = [];
      // console.log(this.form.properties.images);
      if (
        this.form?.properties?.images &&
        this.form.properties.images.length > 0
      ) {
        for (const image of this.form.properties.images) {
          fetch(
            `${
              process.env.VUE_APP_API_BASE_URL
            }/api/v1/component/download?docData=${JSON.stringify(image)}`,
            {
              method: "GET",
              // body: JSON.stringify({
              //   // componentId: 1,
              // }),
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.localStorage.token}`
              },
            }
          )
            .then(async (res) => res.blob())
            .then((blob) => {
              // console.log(blob);
              if (blob.type.includes("image")) {
                this.imageUrl.push({
                  name: image.name,
                  src: window.URL.createObjectURL(new Blob([blob])),
                });
              }
              if (blob.type.includes("pdf")) {
                this.pdfUrl.push({
                  name: image.name,
                  src: window.URL.createObjectURL(new Blob([blob])),
                });
              }

              console.log(this.pdfUrl);

              // }
            });
        }
      }
    },
    deleteFile(file, type) {
      if (type === "pdf") {
        this.pdfUrl = this.pdfUrl.filter((item) => item.name !== file.name);
      }
      if (type === "image") {
        this.imageUrl = this.imageUrl.filter((item) => item.name !== file.name);
      }

      this.form.properties.images = this.form.properties.images.filter(
        (item) => item.name !== file.name
      );
      //       this.getImages()
      // console.log(this.form.properties.images);
    },
    onSubmit() {

      console.log(this.form);
      this.isLoading = true;

      if (!this.form.properties.images) {
        this.form.properties.images = [];
      }

      if (this.$refs.file.files.length > 0) {
        console.log("il y a des fichiers");
        for (const file of this.$refs.file.files) {
          this.form.properties.images.push({
            name: file.lastModified,
            type: file.type,
          });
        }
      }

      this.form.lastModification = localStorage.user;

      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/component/" +
          (this.editItem ? "updateQuestion" : "saveQuestion"),
        {
          method: "POST",
          body: JSON.stringify(this.form),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then(async () => {
          await this.uploadFiles();
          this.isLoading = false;
          
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 6000);
        })
        .catch((error) => {
          this.errorMessage = error;
          console.error("There was an error!", error);
          this.isLoading = false;
        });
    },
    getTechnologyByUsage(usageId) {
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/component/getTechnologyByUsage",
        {
          method: "POST",
          body: JSON.stringify({
            usageId: usageId,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          this.technologies = json.map((item) => {
            item.value = item;
            item.text = item.name;
            return { ...item };
          });
          this.technology = this.technologies[0];
        });
    },
    getComponentByTechnology(technologyId) {
      // console.log(technologyId);
      // console.log(this.components);

      this.filterComponents = this.components
        .map((item) => {
          if (item.technologyId === technologyId) {
            item.value = item;
            item.text = item.name;
            return { ...item };
          }
        })
        .filter((item) => item);

      // fetch(
      //   process.env.VUE_APP_API_BASE_URL +
      //     "/api/v1/component/getComponentByTechnology",
      //   {
      //     method: "POST",
      //     body: JSON.stringify({
      //       technologyId: technologyId,
      //     }),
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${this.localStorage.token}`
      //     },
      //   }
      // )
      //   .then((response) => response.json())
      //   .then((json) => {
      //     console.log(json);
      //     this.components = json.map((item) => {
      //       item.value = item;
      //       item.text = item.name;
      //       return { ...item };
      //     });
      //     console.log(json);
      //   });
    },
    selectedTechnology(technology) {
      this.getComponentByTechnology(technology.id);
    },
    addAnswer() {
      this.form.answers.push({
        operator:
          this.operators[
            this.operators.findIndex(
              (item) =>
                item ===
                this.form.answers[this.form.answers.length - 1].operator
            ) + 1
          ],
        valueAnswer: "",
        toleranceCoefficient: "0",
        isDefault: false,
        unit: "mm",
        shortTermImpact: "Aucun",
        longTermImpact: "Aucun",
        natureOfImpact: ["Aucun"],
        correction: "",
        frequency: "Aucune",
        then: "",
      });
      //          return this.operators.filter((item)=>this.form.answers.find((op)=>op.operator === item) ? '' : item);
    },
    removeAnswer() {
      this.form.answers.pop();
      //          return this.operators.filter((item)=>this.form.answers.find((op)=>op.operator === item) ? '' : item);
    },
    selectedComponents(components) {
      console.log(components);
     
      this.form.components = [...components];


    },
    toleranceChange() {
      console.log(this.form.toleranceCoefficient);
      console.log(this.form.toleranceCoefficient);
    },
    changeTypo() {
      console.log(this.form.buildings);
    },
    onAutoRefChange() {
      // console.log(this.form.installationCharacteristic);
      if (this.form.autoReference) {
        (this.form.autoreferenceValue = "installationCharacteristic"),
          (this.form.answerType = "");
        this.form.answers = [
          {
            valueAnswer: "",
            toleranceCoefficient: "0",
            operator: "=",
            unit: "mm",
            shortTermImpact: "Aucun",
            longTermImpact: "Aucun",
            natureOfImpact: ["Surconsommation d'énergie"],
            correction: "",
            frequency: "Aucune",
            then: "",
          },
        ];
      }else {
        this.form.installationCharacteristic = {};
        this.form.autoreferenceValue = "";
      }
    },
    onAutoRefValueChange() {
      console.log(this.form.autoreferenceValue);
      // if (this.form.autoreferenceValue === "documentaryValue") {
      //   this.form.installationCharacteristic = {};
      // }
    },
    sleep(milliseconds) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds));
    },
    // async testAnswers(isAutoReference, answerType, answers) {
    //   this.testResult = "";
    //   let fixedDec = 0;

    //   let interval = this.userAnswerInterval;
    //   console.log(interval);
    //   console.log(isAutoReference);
    //   if (isAutoReference) {
    //     // toleranceCoefficient
    //     //  this.userAnswerMax = 105;
    //     // console.log(answers);
    //     for (
    //       let userDocumentaryAnalysisAnswer = Number(this.userAnswerBeginValue);
    //       userDocumentaryAnalysisAnswer < this.userAnswerMax;
    //       userDocumentaryAnalysisAnswer += Number(interval)
    //     ) {
    //       for (
    //         let userVisualCheckAnswer = Number(this.userAnswerBeginValue);
    //         userVisualCheckAnswer < this.userAnswerMax;
    //         userVisualCheckAnswer += Number(interval)
    //       ) {
    //         await this.sleep(0);

    //         this.userAnswerTest = Number(userDocumentaryAnalysisAnswer);

    //         //       var errorNbre = 0;
    //         // var answerOk = 0;
    //         // console.log(answers.find((item)=> item.valueAnswer == userDocumentaryAnalysisAnswer && item.operator == '='));

    //         //EQUAL
    //         let respEqual = answers.find((item) => {
    //           let minUserAnswer = 0;
    //           let maxUserAnswer = 0;

    //           switch (item.documentaryValueModifierOperator) {
    //             case "X":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer *
    //                 item.documentaryValueModifierValue;
    //               break;
    //             case "+":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer +
    //                 item.documentaryValueModifierValue;
    //               break;
    //             case "-":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer -
    //                 item.documentaryValueModifierValue;
    //               break;

    //             default:
    //               break;
    //           }
    //           // if (item.toleranceCoefficient && item.toleranceCoefficient > 0) {
    //           minUserAnswer = Number(
    //             Number(
    //               userDocumentaryAnalysisAnswer *
    //                 (1 - item.toleranceCoefficient / 100)
    //             )
    //           ).toFixed(fixedDec);
    //           maxUserAnswer = Number(
    //             Number(
    //               userDocumentaryAnalysisAnswer *
    //                 (1 + item.toleranceCoefficient / 100)
    //             )
    //           ).toFixed(fixedDec);
    //           // console.log(minUserAnswer);
    //           // console.log(maxUserAnswer);
    //           return (
    //             Number(userVisualCheckAnswer) > minUserAnswer &&
    //             Number(userVisualCheckAnswer) < maxUserAnswer &&
    //             item.operator == "="
    //           );
    //           // }
    //           // return Number(userVisualCheckAnswer) ==
    //           //   Number(Number(userDocumentaryAnalysisAnswer).toFixed(fixedDec)) &&
    //           // item.operator == "="
    //         });

    //         // INFERIOR
    //         let respInf = answers.find((item) => {
    //           // let minUserAnswer = 0;

    //           switch (item.documentaryValueModifierOperator) {
    //             case "X":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer *
    //                 item.documentaryValueModifierValue;
    //               break;
    //             case "+":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer +
    //                 item.documentaryValueModifierValue;
    //               break;
    //             case "-":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer -
    //                 item.documentaryValueModifierValue;
    //               break;

    //             default:
    //               break;
    //           }
    //           // if (item.toleranceCoefficient && item.toleranceCoefficient > 0) {
    //           userDocumentaryAnalysisAnswer =
    //             userDocumentaryAnalysisAnswer *
    //             (1 - item.toleranceCoefficient / 100);

    //           return (
    //             userVisualCheckAnswer < userDocumentaryAnalysisAnswer &&
    //             item.operator == "<"
    //           );
    //           // }

    //           // return Number(Number(userVisualCheckAnswer).toFixed(fixedDec)) < Number(Number(userDocumentaryAnalysisAnswer).toFixed(fixedDec))
    //           //    && item.operator == "<"
    //         });

    //         // SUPERIOR
    //         let respSup = answers.find((item) => {
    //           // let maxUserAnswer = 0;

    //           switch (item.documentaryValueModifierOperator) {
    //             case "X":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer *
    //                 item.documentaryValueModifierValue;
    //               break;
    //             case "+":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer +
    //                 item.documentaryValueModifierValue;
    //               break;
    //             case "-":
    //               userDocumentaryAnalysisAnswer =
    //                 userDocumentaryAnalysisAnswer -
    //                 item.documentaryValueModifierValue;
    //               break;

    //             default:
    //               break;
    //           }
    //           // if (item.toleranceCoefficient && item.toleranceCoefficient > 0) {
    //           userDocumentaryAnalysisAnswer =
    //             userDocumentaryAnalysisAnswer *
    //             (1 + item.toleranceCoefficient / 100);

    //           return (
    //             userVisualCheckAnswer >= userDocumentaryAnalysisAnswer &&
    //             item.operator == ">="
    //           );
    //           // }

    //           // return Number(Number(userVisualCheckAnswer).toFixed(fixedDec)) >= Number(Number(userDocumentaryAnalysisAnswer).toFixed(fixedDec))
    //           //    && item.operator == ">="
    //         });
    //         // console.log(respEqual);
    //         // console.log(respInf);
    //         // console.log(respSup);

    //         if (!respEqual && !respInf && !respSup) {
    //           this.testResult =
    //             "pas de cas traité à partir de " + userVisualCheckAnswer;
    //           return;
    //         }
    //         if ((respEqual && (respInf || respSup)) || (respInf && respSup)) {
    //           this.testResult =
    //             "collision de cas à partir de" + userVisualCheckAnswer;
    //           return;
    //         }
    //         this.testResult = "OK";
    //       }
    //     }
    //   }

    //   // console.log(isAutoReference);
    //   // console.log(answerType);
    //   if (!isAutoReference && answerType === "number") {
    //     // console.log(this.form.answers);
    //     if (
    //       String(this.form.answers[0].valueAnswer)
    //         .replace(/,/g, ".")
    //         .includes(".")
    //     ) {
    //       fixedDec = String(this.form.answers[0].valueAnswer)
    //         .replace(/,/g, ".")
    //         .split(".")[0].length;
    //     }
    //     //  this.userAnswerMax = 105;
    //     // console.log(answers);
    //     for (
    //       let userAnswer = Number(this.userAnswerBeginValue);
    //       userAnswer < this.userAnswerMax;
    //       userAnswer += Number(interval)
    //     ) {
    //       // console.log(this.userAnswerMax);
    //       // console.log(this.userAnswerInterval);
    //       // await this.sleep(0);
    //       // console.log(userAnswer);
    //       this.userAnswerTest = Number(userAnswer.toFixed(2));
    //       // console.log(Number(Number(userAnswer).toFixed(fixedDec)));

    //       //       var errorNbre = 0;
    //       // var answerOk = 0;
    //       // console.log(answers.find((item)=> item.valueAnswer == userAnswer && item.operator == '='));
    //       let respEqual = answers.find(
    //         (item) =>
    //           Number(item.valueAnswer) ==
    //             Number(Number(userAnswer).toFixed(fixedDec)) &&
    //           item.operator == "="
    //       );
    //       let respInf = answers.find(
    //         (item) =>
    //           Number(Number(userAnswer).toFixed(fixedDec)) <
    //             Number(Number(item.valueAnswer).toFixed(fixedDec)) &&
    //           item.operator == "<"
    //       );
    //       let respSup = answers.find(
    //         (item) =>
    //           Number(Number(userAnswer).toFixed(fixedDec)) >=
    //             Number(Number(item.valueAnswer).toFixed(fixedDec)) &&
    //           item.operator == ">="
    //       );

    //       // console.log(respEqual);
    //       // console.log(respInf);
    //       // console.log(respSup);
    //       // console.log("------------------------------------------------");

    //       if (!respEqual && !respInf && !respSup) {
    //         this.testResult = "pas de cas traité à partir de " + userAnswer;
    //         return;
    //       }
    //       if ((respEqual && (respInf || respSup)) || (respInf && respSup)) {
    //         this.testResult =
    //           "collision de cas à partir de " +
    //           Number(userAnswer).toFixed(fixedDec);
    //         return;
    //       }
    //       this.testResult = "OK";
    //     }
    //   }
    // },
    charChange() {
           console.log(this.form.installationCharacteristic);
      if (this.form.installationCharacteristic.name === 'plusieursBallons') {
        this.form.answerType = 'multipleChoice'
        
      }
    },
    priorityCalculation() {
      this.priorityArray = [];

      let impact = 0;
      let frequency = 0;

      for (const item of this.form.answers) {
        let maxImpact = [];

        console.log(item);
        switch (item.longTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        switch (item.shortTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        switch (item.frequency) {
          case "Faible":
            frequency = 1;
            break;
          case "Moyen":
            frequency = 2;
            break;
          case "Fort":
            frequency = 4;
            break;
          case "Variable":
            frequency = 2;
            break;
          case "Aucune":
            frequency = 0;
            break;
        }
        impact = Math.max(...maxImpact);
        this.priorityArray.push(impact * frequency);
      }
      this.form.priority = Math.max(...this.priorityArray);

      this.form.properties.priority2 = this.priorityArray.reduce(
        (acc, curr) => acc + curr,
        0
      );
      // console.log(this.form.properties.priority2);
    },
    weightCalculation() {
      // console.log(this.form.priority);
      this.weightArray = [];

      let impact = 0;

      for (const item of this.form.answers) {
        let maxImpact = [];
        switch (item.longTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        switch (item.shortTermImpact) {
          case "Faible":
            maxImpact.push(1);
            break;
          case "Moyen":
            maxImpact.push(2);
            break;
          case "Fort":
            maxImpact.push(4);
            break;
          case "Hors service":
            maxImpact.push(20);
            break;

          case "Aucun":
            maxImpact.push(0);
            break;
        }
        impact = Math.max(...maxImpact);
        this.weightArray.push(impact);
      }
      this.form.properties.weight = Math.max(...this.weightArray);
    },
    calculateWeightAndPriority() {
      this.weightCalculation();
      this.priorityCalculation();
    },
    uploadFiles() {
      // console.log(this.$refs.file.files);
      const options = {
        // maxSizeMB: 1, // number(default: Number.POSITIVE_INFINITY)
        // maxWidthOrHeight, // number compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
        // but, automatically reduce the size to smaller than the maximum Canvas size supported by each browser.
        // Please check the Caveat part for details.
        // onProgress: Function, // optional, a function takes one progress argument (percentage from 0 to 100)
        // useWebWorker: boolean, // optional, use multi-thread web worker, fallback to run in main-thread (default: true)

        // following options are for advanced users
        // maxIteration: number, // optional, max number of iteration to compress the image (default: 10)
        // exifOrientation: number, // optional, see https://stackoverflow.com/a/32490603/10395024
        // fileType: string, // optional, fileType override
        initialQuality: 0.2, // optional, initial quality value between 0 and 1 (default: 1)
      };
      var files = this.$refs.file.files;
      var promises = files.map(async (file) => {
        // console.log(file);
        if (file.type.includes("image")) {
          file = await imageCompression(file, options);
          // console.log(file.size);
        }

        // const imgName = file.name;
        const formData = new FormData();
        formData.append(file.lastModified, file);

        // formData.append(imgName.split(".")[0], file);
        // formData.set('questionId', questionId);

        return new Promise((resolve) => {
          fetch(
            process.env.VUE_APP_API_BASE_URL +
              "/api/v1/component/uploadFromComponent",
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${this.localStorage.token}`
              },
              body: formData,
            }
          ).then(() => resolve());
        });
      });
      return Promise.all(promises);
    },
    isDefaultChange(index, isNotDefault) {
      if (isNotDefault) {
        this.form.answers[index].natureOfImpact = ["Aucun"];
        this.form.answers[index].shortTermImpact = "Aucun";
        this.form.answers[index].longTermImpact = "Aucun";
        this.form.answers[index].natureOfImpact = ["Aucun"];
        this.form.answers[index].correction = "";
        this.form.answers[index].frequency = "Aucune";
      }
    },
    openFile(file) {
      this.isFullscreen = true;
      let loadingTask = pdf.createLoadingTask(file);
      loadingTask.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
      this.sourceFile = file;
    },
    selectLocal(ev) {
      console.log(ev);
    },
    changeCat(cat) {
      this.form.cat = this.categories.find((item) => item.id === cat);
    },
  },
  watch: {},
  // computed: {
  //   operatorsComp() {
  //          return this.operators.filter((item)=>this.form.answers.find((op)=>op.operator === item) ? '' : item);
  //   }
  // }
};
</script>
<style>
.modal-xl {
  max-width: 95% !important;
}
.w_250 {
  width: 40%;
}

.cardHeader {
  text-align: right;
  color: #ffffff;
  font-size: 1.2em;
  font-weight: bold;
}

.font_bold {
  font-weight: bold;
}

.fs_15 {
  font-size: 1.4em;
}
</style>
